function isZeroQuery(obj) {
  if (!obj) return false;
  if (typeof obj !== "object") return false;
  if (!obj.ast || !obj.ast.table) return false;
  return true;
}
export {
  isZeroQuery
};
//# sourceMappingURL=isZeroQuery.js.map
